module.exports = __webpack_public_path__ + "img/hr-red-pita-07.a18fcb2a.png";